/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */

import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { TextField } from '@material-ui/core';
import { IEntityFieldProps, useEntity } from 'icerockdev-admin-toolkit';
import { observer } from 'mobx-react';
import styles from './styles.module.scss';
import { ExchangeEntity } from '~/config/pages/exchange/components/ExchangeEntity';

type IProps = IEntityFieldProps & {};

const ExchangeTextarea: FC<IProps> = observer(({ value, ...props }) => {
  const entity = useEntity<ExchangeEntity>();
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    setIsShow(false);
    entity.settings.forEach((el) => {
      if (el.fieldName === props.name) {
        setIsShow(true);
      }
    });
  }, [entity.settings, props.name]);

  const onChange = useCallback(
    (event) => {
      if (!props.handler) return;

      props.handler(event.target.value);
    },
    [props]
  );

  if (!isShow) return null;

  return (
    <div>
      <TextField
        multiline
        label={props.label}
        value={value || ''}
        onChange={onChange}
        error={!!props.error}
        helperText={props.error}
        variant="outlined"
        placeholder={props.placeholder || ''}
      />
    </div>
  );
});

export { ExchangeTextarea };
